import api from 'services/system/forgot-password'
import { history } from 'utils/history'

export const handleSend = async (values: any) => {
  if (await api.send(values)) history.push('/forgot-password/update-password')
}
